import React from "react";

const LinkPreviewElement = ({ attributes, element, children }) => {
  return (
    <div {...attributes} contentEditable={false} style={{
      border: "1px solid #ccc",
      borderRadius: "8px",
      padding: "1rem",
      display: "flex",
      alignItems: "center",
      gap: "1rem",
      margin: "1rem 0",
      backgroundColor: "#fafafa"
    }}>
      {element.image && (
        <img
          src={element.image}
          alt={element.title}
          style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "8px" }}
        />
      )}
      <div>
        <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>{element.title}</div>
        <div style={{ color: "#555", fontSize: "0.9rem" }}>{element.description}</div>
        <a href={element.url} target="_blank" rel="noopener noreferrer" style={{ marginTop: "0.5rem", display: "inline-block", color: "#1677ff" }}>
          Open Link
        </a>
      </div>
      {children}
    </div>
  );
};

export default LinkPreviewElement;
